import React from "react";
import { FaSearch } from "react-icons/fa";
import { MdVisibility } from "react-icons/md";
import Pagination from "../../../../helper/Pagination";

const AlmataOemTable = ({
  partners,
  loading,
  searchTerm,
  handleSearchChange,
  currentPage,
  pagination,
  setCurrentPage,
  handleTableRowClick,
  handleViewDetails,
}) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div className="table-section">
      <div className="d-flex justify-content-end align-items-center mb-2">
        <div className="d-flex gap-3">
          <div className="position-relative">
            <input
              type="search"
              placeholder="Search by Name & Email..."
              className="form-input"
              value={searchTerm}
              onChange={handleSearchChange}
              style={{ width: "200px" }}
            />
            {searchTerm === "" && (
              <div
                className="position-absolute"
                style={{
                  top: "50%",
                  right: "13px",
                  color: "#666",
                  transform: "translateY(-50%)",
                }}
              >
                <FaSearch />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="table-scroll-wrapper">
        <table className="partners-table">
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Logo</th>
              <th>Company Name</th>
              <th>Email</th>
              <th>Contact Person</th>
              <th>Phone</th>
              <th>Country</th>
              <th>Currency</th>
              <th>Status</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan="12"
                  style={{
                    textAlign: "center",
                    padding: "40px",
                    color: "#666",
                  }}
                >
                  <div className="loading-spinner">
                    <div className="spinner"></div>
                    <p>Loading OEM partners...</p>
                  </div>
                </td>
              </tr>
            ) : partners.length === 0 ? (
              <tr>
                <td
                  colSpan="12"
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    color: "#666",
                  }}
                >
                  No OEM partners found
                </td>
              </tr>
            ) : (
              partners
                .filter((partner) => partner && partner.companyName)
                .map((partner, index) => (
                  <tr
                    key={partner._id}
                    style={{ cursor: "pointer" }}
                    className="table-row-clickable"
                  >
                    <td
                      onClick={() =>
                        handleTableRowClick && handleTableRowClick(partner)
                      }
                    >
                      {index + 1}
                    </td>
                    <td
                      onClick={() =>
                        handleTableRowClick && handleTableRowClick(partner)
                      }
                    >
                      <img
                        src={partner.logo}
                        alt={partner.companyName}
                        className="partner-logo-table"
                        style={{
                          width: "32px",
                          height: "30px",
                          objectFit: "contain",
                          borderRadius: "8px",
                          border: "1px solid #ddd",
                          backgroundColor: "#c5c7caff",
                        }}
                      />
                    </td>
                    <td
                      title={
                        partner.companyName && partner.companyName.length > 20
                          ? partner.companyName
                          : ""
                      }
                      style={{
                        cursor:
                          partner.companyName && partner.companyName.length > 20
                            ? "pointer"
                            : "default",
                      }}
                      onClick={() =>
                        handleTableRowClick && handleTableRowClick(partner)
                      }
                    >
                      {partner.companyName
                        ? partner.companyName.length > 20
                          ? partner.companyName.charAt(0).toUpperCase() +
                            partner.companyName.substring(1, 20) +
                            "..."
                          : partner.companyName.charAt(0).toUpperCase() +
                            partner.companyName.slice(1)
                        : "N/A"}
                    </td>
                    <td
                      onClick={() =>
                        handleTableRowClick && handleTableRowClick(partner)
                      }
                    >
                      {partner.email || "N/A"}
                    </td>
                    <td
                      onClick={() =>
                        handleTableRowClick && handleTableRowClick(partner)
                      }
                    >
                      {partner.firstName} {partner.lastName}
                    </td>
                    <td
                      onClick={() =>
                        handleTableRowClick && handleTableRowClick(partner)
                      }
                    >
                      {partner.countryCode && partner.contactNumber
                        ? `(${partner.countryCode}) ${partner.contactNumber}`
                        : partner.contactNumber || "N/A"}
                    </td>
                    <td
                      onClick={() =>
                        handleTableRowClick && handleTableRowClick(partner)
                      }
                    >
                      {partner.country}
                    </td>
                    <td
                      onClick={() =>
                        handleTableRowClick && handleTableRowClick(partner)
                      }
                    >
                      {partner.currency}
                    </td>
                    <td
                      onClick={() =>
                        handleTableRowClick && handleTableRowClick(partner)
                      }
                    >
                      <span
                        className={`badge ${
                          partner.status === "active"
                            ? "bg-success"
                            : "bg-secondary"
                        }`}
                      >
                        {partner.status?.toUpperCase()}
                      </span>
                    </td>
                    <td
                      onClick={() =>
                        handleTableRowClick && handleTableRowClick(partner)
                      }
                    >
                      {formatDate(partner.createdAt)}
                    </td>
                    <td>
                      <div className="row-actions">
                        <div
                          className="view-row-btn"
                          title="View details"
                          style={{
                            color: "#666",
                            cursor: "pointer",
                            marginRight: "8px",
                          }}
                          onClick={() => handleViewDetails(partner)}
                        >
                          <MdVisibility />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={pagination.totalPages}
        totalItems={pagination.totalItems}
        itemsPerPage={pagination.itemsPerPage}
        onPageChange={setCurrentPage}
      />
    </div>
  );
};

export default AlmataOemTable;
